import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import {
    FaEnvelope,
    FaLock,
    FaEye,
    FaEyeSlash,
    FaExclamationCircle,
} from 'react-icons/fa';

import RegisterFlow from './RegisterFlow';
import './Login.css';

const Login = (props) => {
    const [mode, setMode] = useState(props.register ? 'register' : 'login');
    const [mail, setMail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const login = async (e) => {
        e.preventDefault();

        if (!mail || !password) {
            setError("Renseigne ton email et ton mot de passe.");
            return;
        }

        setError("");
        setLoading(true);

        try {
            const response = await axios.get('https://unbot.io/api/v1.0/auth', {
                params: { mail, password }
            });

            if (!response.data) {
                setLoading(false);
                return;
            }

            if (response.data.error) {
                setError(response.data.error.message);
                setLoading(false);
                return;
            }

            const { jwt } = response.data;
            Cookies.set('user_token', jwt, { expires: 365 });
            props.onLogin();
        } catch (err) {
            const apiMessage = err?.response?.data?.error?.message;
            setError(apiMessage || "Email ou mot de passe incorrect.");
            setLoading(false);
        }
    };

    const switchTo = (nextMode) => {
        setError("");
        setMode(nextMode);
    };

    return (
        <div className="login-page">
            <Helmet>
                <title>Connexion Unbot</title>
                <meta name="description" content="Connectez-vous ou inscrivez-vous sur Unbot" />
                <meta name="keywords" content="connexion Unbot, inscription assistant IA, login Uncove agent" />
            </Helmet>
            <div className="login-container">
                {mode === 'login' && (
                    <form onSubmit={login}>
                        <h1 className="login-title">Bienvenue</h1>
                        <p className="login-subtitle">Connecte-toi à ton compte Unbot.</p>

                        {error && (
                            <div className="auth-error" role="alert">
                                <FaExclamationCircle />
                                <span>{error}</span>
                            </div>
                        )}

                        <label className="auth-label" htmlFor="login-email">Ton email</label>
                        <div className="auth-field">
                            <span className="auth-field-icon"><FaEnvelope /></span>
                            <input
                                id="login-email"
                                type="email"
                                className="auth-input"
                                placeholder="exemple@email.com"
                                value={mail}
                                onChange={(e) => { setMail(e.target.value); setError(""); }}
                                autoFocus
                                required
                            />
                        </div>

                        <label className="auth-label" htmlFor="login-password">Mot de passe</label>
                        <div className="auth-field">
                            <span className="auth-field-icon"><FaLock /></span>
                            <input
                                id="login-password"
                                type={showPassword ? 'text' : 'password'}
                                className="auth-input has-toggle"
                                placeholder="Ton mot de passe"
                                value={password}
                                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                                required
                            />
                            <button
                                type="button"
                                className="auth-toggle"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>

                        <button type="submit" className="next-button" disabled={loading}>
                            {loading ? 'Connexion…' : 'Se connecter'}
                        </button>

                        <p className="account-text" onClick={() => switchTo('register')}>
                            Je n'ai pas de compte Unbot <span className="auth-link">M'inscrire</span>
                        </p>
                    </form>
                )}

                {mode === 'register' && (
                    <RegisterFlow
                        onLogin={props.onLogin}
                        onSwitchToLogin={() => switchTo('login')}
                        onClose={props.onClose}
                    />
                )}
            </div>
        </div>
    );
};

export default Login;
